export function getLocalUptime (state) {
    return state.uptime
}

export function getTeoriaStats (state) {
    return state.teoriaStats
}
